export default function validatePhone(phone: string) {
    const regex = new RegExp(/^\+[1-9]\d{6,14}$/)
    return regex.test(phone)
}